import { Row, Tooltip, Col } from 'antd';
import DeleteIcon from 'components/Icons/DeleteIcon';
import NewCopyDarkIcon from 'components/Icons/NewCopyDarkIcon';
import VariablesEditIcon from 'components/Icons/VariablesEditIcon';

const VariableEditMenu = ({
  copyVariable,
  onRenameClick,
  deleteCustomVariable,
  copiedVariable,
  value,
  variable,
  variableKeyName,
}) => {
  return (
    <Col>
      <Tooltip
        title="Copied!"
        visible={copiedVariable === variableKeyName}
        className={`elements-menu-drag ${copiedVariable === variableKeyName ? 'copied' : ''}`}>
        <Row className="custom-menu-item copy" onClick={(e) => copyVariable(value, variable)}>
          <NewCopyDarkIcon className="custom-menu-item-icon" />
          Copy
        </Row>
      </Tooltip>
      <Row className="custom-menu-item edit" onClick={() => onRenameClick(value, variable)}>
        <VariablesEditIcon className="custom-menu-item-icon" />
        Rename
      </Row>
      <Row className="custom-menu-item delete" onClick={(e) => deleteCustomVariable(variable)}>
        <DeleteIcon className="custom-menu-item-icon" />
        Delete
      </Row>
    </Col>
  );
};

export default VariableEditMenu;
